





























































import { Component, Vue, Prop } from 'vue-property-decorator';
import moment from 'moment';

const getTimeFormatted = num => num < 10 ? `0${num}` : num
const TIMES = Array(25).fill(null).map((_, i) => `${getTimeFormatted(i)}:00`)

const splitTime = time => {
  const [t1, t2]	= time.split(':')

  const offset = +t2 <= 30 ? 0 : 1
  return +t1 + offset
}

@Component
export default class UiPeriodPicker extends Vue {
  @Prop({ default: false })
  withTimeFilter: boolean;

  @Prop()
  value: string;

  @Prop()
  disabled: boolean;

  @Prop({default: 'YYYY-MM-DD HH:mm:ss'})
  format: string;

  @Prop({default: null})
  minDate: string;

  @Prop({default: null})
  maxDate: string;

  date: Date = new Date(this.value);
  time: string = `${getTimeFormatted(splitTime(moment(this.value).format('HH:mm')))}:00` || TIMES[0];

  get dateValue() {
    return this.date
  }

  set dateValue(value) {
    this.date = value || new Date()
  }

  onChange() {
    if (this.isSameDay(this.date)) {
      const availableTime = Math.max(splitTime(this.time), +moment().format('HH') + 1)
      this.time = `${getTimeFormatted(availableTime)}:00`
    }

    const hour = splitTime(this.time)

    let date = moment(this.date).startOf('day').add(hour, 'hour')

    if (hour === 24) {
      date.subtract(1, 'seconds')
    }

    this.$emit('input', date)
  }

  get times() {
    return TIMES.map(time => ({ value: time }))
  }

  isSameDay(now, today = moment()) {
    return moment(today).isSame(now, 'day')
  }

  get availableTimes() {
    if (this.withTimeFilter && this.isSameDay(this.date)) {
      const now = +moment().format('HH')
      return this.times.map(({ value }) => {
        const hour = +value.split(':')[0]
        return ({
          value,
          disabled: hour < now + 1,
        })
      })
    }
    return this.times
  }

  get text() {
    return `${this.dateFormatted} ${this.time}`;
  }

  get dateFormatted() {
    return moment(this.date).format('DD MMM YYYY');
  }

  toggleMenu() {
    const picker = this.$refs.picker as any;
    picker.toggleMenu(false);
  }
}
